import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/reports/reports-routing.module.ts